import { text, pgTable, uuid } from 'drizzle-orm/pg-core';
import { defaultColumns } from './defaultColumns';
import { relations } from 'drizzle-orm';
import { userRoleTable } from './userRole.sql';

export const roleTable = pgTable('role', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: text('name').notNull(),
  description: text('description'),
  ...defaultColumns,
});

export const roleRelations = relations(roleTable, ({ many }) => ({
  userRoles: many(userRoleTable),
}));
